export class IdCounter {
  private value: number;

  constructor(start = 0) {
    this.value = start;
  }

  next(): number {
    return this.value++;
  }

  current(): number {
    return this.value;
  }

  reset(start = 0): void {
    this.value = start;
  }
}
